export default {
    ambassadorBtn_title: "Disegno della carta regalo",
    ambassadorBtn_subtitle: "Reviews = Rewards",
    ambassadorPopup_title: "PARTECIPARE ALL'ESTRAZIONE DI UNA CARTA REGALO",
    ambassadorPopup_votes: '20 AirVotes',
    giveawayPopup_login: "Accedi a Google o Facebook",
    ambassadorPopup_review: "Lascia una recensione su una delle pagine di {v1}",
    giveawayPopup_entered: "Sarai inserito in",
    ambassadorPopup_BtnLogin: "Inizia con il login",
    giveawayPopup_BtnReview: "Lascia una recensione su una qualsiasi delle pagine di",
    ambassadorPopup_cancel: "Non voglio partecipare",
    ambassadorFinishTitle: "Apprezziamo la tua onesta recensione! Sei stato aggiunto all'estrazione del nostro giveaway. Torna a votare di nuovo: ogni voto aumenta le tue possibilità!",
    ambassadorMonthlyDrawing: "Every AirVote enters you into a monthly $100 drawing",
    ambassadorReceive: "Ambassadors will receive extra goodies and recognition!",
    ambassadorHelpUsTogether: "Help us succeed together!",
    giveawayPopup_proceedReview: "Procedere all'invio di una recensione",
    Thank_for_vote: "Grazie per il tuo voto. Vuoi tenere traccia dei tuoi voti? Accedi utilizzando",
    thankVoteTitle1: "Feedback salvato",
    thankVoteTitle2_1: "Grazie per aver votato",
    thankVoteTitle2_2: "Iscriviti ad AirVote per poter rivedere e cambiare i tuoi voti",
    writeFeedBack: "Aggiungi una nota (opzionale)",
    voteSuccessText_1: "Voto inviato, grazie!",
    voteSuccessText_2: "Vuoi cambiarlo? Tocca un altro smiley.",
    voteSuccessText_3: "Hai qualcosa da dire? Lascia una nota opzionale",
    feedbackTitle: "Aggiungi una nota",
    feedbackTitleSoSo: "Cosa potrebbe essere meglio?",
    feedbackTitleSad: "Cosa non va bene?",
    feedbackTextRating: 'Perché ha assegnato a questo diffusore questa valutazione?',
    writeAReview: "Scrivi una recensione",
    writeAReviewTitle: "Puoi scrivere una recensione per {v1} qui:",
    yourNote: "La tua nota",
    addYourNote: "Aggiungi una nota ?",
    commentPopupEmail: "Inserisci la tua email o il tuo telefono",
    feedbackText: "Voglio avere una risposta su questo",
    feedbackTextServiceLog: "Informazioni di contatto del servizio",
    feedbackHelpText: "Il proprietario del posto lo riceverà per mettersi in contatto con te",
    title_404: "La pagina che stai cercando di raggiungere non è disponibile",
    Submit: "Invia il tuo commento",
    Cancel: "Annulla",
    Logout: "Logout",
    Sync_status: "Sincronizzare lo stato",
    reviewSocial: "Chi siamo",
    anonComment: "Aggiungi un commento anonimo",
    powered_by: "Powered by AirVote\nGet it for your business",
    QR_smiley_disabled: "Ce QR Smiley® a été désactivé.\nVeuillez adresser vos commentaires directement à l'entreprise.",
    QR_smiley_disabled_links: "Des questions sur AirVote® ?\nConsultez le site {v1} ou envoyez-nous un courriel à {v2}.",
    QR_smiley_disabled_footer: "Merci de nous faire part de vos commentaires!",
    manageNotEnoughPermissions: "Non hai abbastanza permessi per gestire questa domanda AirVote. Accedi con un altro account o chiedi un permesso",
    welcomeAmbassador: "Welcome back, J Bar Ambassador!",
    ambassadorDescription: "Every AirVote enters you into a monthly $100 drawing (limit 1 per location per day)\n" +
        "Ambassadors will receive extra goodies and recognition!\n" +
        "\n" + "Help us succeed together!",
    Placement: "Posizionamento",
    Update: "Aggiornare",
    NewPlacementSaved: "Salvataggio del nuovo posizionamento riuscito",
    PleaseEnterCorrectPlacement: "Si prega di inserire il posizionamento corretto",
    manageGPSAllowTitle: "Ti dispiace condividere la tua posizione?",
    manageGPSAllowText: "Conoscere la posizione esatta di un problema ci aiuta a risolverlo più rapidamente. Non terremo traccia della tua posizione né la condivideremo con nessuno al di fuori del nostro team di assistenza",
    manageGPSAllowOKButton: "OK per condividere",
    manageGPSAllowCancelButton: 'Preferisco di no',
    level2_notp: "Senza carta igienica",
    level2_full: "Pieno",
    level2_dirty: "Sporco",
    level2_smells: "Puzza",
    level2_broken: "Qualcosa roto",
    level2_otherl: "Altro",
    level2_nopaper: "Nessun asciugamano",
    level2_title: "Servizi Svolti",
    level2_maxCount: "Numero massimo di articoli tra cui scegliere: {v1}",
    need_audio_permission_error: "Dacci accesso al tuo microfono per registrare l'audio",
    vote_screen_public_review_popup_title: "Lasciaci una recensione pubblica",
    sl_final_Title1: "Service log saved!",
    serviceLogInfoBtn: "Cronologia del servizio",
    snapPicturePopupTitle: "Confermate il vostro voto con la foto del bagno",
    snapPictureButton: "Scattare una foto",
    snapPicturePopupContinue: "Continue",
    subtitleDefault: "La tua foto del problema è apprezzata!",
    signIn_Pin: "Sign in with PIN",
}
